

















import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import VPercentInput from "@/components/VPercentInput.vue";

@Component({
  components: {
    VPercentInput,
  },
})
export default class DiscountInput extends Vue {
  @Prop({ required: true }) readonly label!: string;
  @Prop({ required: true }) readonly discount!: number;

  destroy() {
    this.$emit("destroy");
  }

  private value = this.discount;

  @Watch("value")
  onValueChanged(value: number) {
    this.$emit("input", value);
  }
}
